/**
 * MessageType enum constant.
 */
export default {
    text: 0,
    link: 1,
    image: 2,
    video: 3,
    card: 4,
    file:5
}